import Index from "./Index.jsx";

const PARAMETERS = {
  INDEX: Index,
};

export default PARAMETERS;